import { render, staticRenderFns } from "./CustomPageForm.vue?vue&type=template&id=ab88647c&scoped=true&"
import script from "./CustomPageForm.vue?vue&type=script&lang=js&"
export * from "./CustomPageForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomPageForm.vue?vue&type=style&index=0&id=ab88647c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab88647c",
  null
  
)

export default component.exports